export const RangeSlider = () => {
    /*function controlfromTooltip(fromSlider, fromTooltip, toTooltip, controlSlider) {
        const [from, to] = getParsed(fromTooltip, toTooltip);
        fillSlider(fromTooltip, toTooltip, 'rgba(0, 104, 180, 0.3)', '#0068B4', controlSlider);
        if (from > to) {
            fromSlider.value = to;
            fromTooltip.value = to;
        } else {
            fromSlider.value = from;
        }
    }*/

    /*function controltoTooltip(toSlider, fromTooltip, toTooltip, controlSlider) {
        const [from, to] = getParsed(fromTooltip, toTooltip);
        fillSlider(fromTooltip, toTooltip, 'rgba(0, 104, 180, 0.3)', '#0068B4', controlSlider);
        setToggleAccessible(toTooltip);
        if (from <= to) {
            toSlider.value = to;
            toTooltip.value = to;
        } else {
            toTooltip.value = from;
        }
    }*/

    function controlFromSlider(fromSlider, toSlider, fromTooltip) {
        const [from, to] = getParsed(fromSlider, toSlider);
        if (from > to - 10) {
            fromSlider.value = to - 10;
        }

        fillSlider(
            fromSlider,
            toSlider,
            'rgba(0, 104, 180, 0.3)',
            'var(--color-primary-900)',
            toSlider,
            fromTooltip,
            toTooltip
        );
        fromTooltip.querySelector('.range__tooltip-text').textContent = `${fromSlider.value}%`
    }

    function controlToSlider(fromSlider, toSlider, toTooltip) {
        const [from, to] = getParsed(fromSlider, toSlider);
        setToggleAccessible(toSlider);
        if (from <= to - 10) {
            toSlider.value = to;
        } else {
            toSlider.value = from + 10;
        }

        fillSlider(
            fromSlider,
            toSlider,
            'rgba(0, 104, 180, 0.3)',
            '#0068B4',
            toSlider,
            fromTooltip,
            toTooltip
        );
        toTooltip.querySelector('.range__tooltip-text').textContent = `${toSlider.value}%`
    }

    function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
    }

    function fillSlider(from, to, sliderColor, rangeColor, controlSlider, fromTooltip, toTooltip) {

        const thumbWidth = 24;
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;

        const left = `calc(${fromPosition / rangeDistance * 100}% - ${(fromPosition) / (rangeDistance)} * ${thumbWidth}px + ${thumbWidth/2}px)`
        const right = `calc(${toPosition / rangeDistance * 100}% - ${(toPosition) / (rangeDistance)} * ${thumbWidth}px + ${thumbWidth/2}px)`
        fromTooltip.style.left = left
        toTooltip.style.left = right

        controlSlider.style.background = `linear-gradient(
            to right,
            ${sliderColor} 0%,
            ${sliderColor} ${left},
            ${rangeColor}  ${left},
            ${rangeColor} ${right},
            ${sliderColor} ${right},
            ${sliderColor} 100%
        )`;
    }



    function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0 ) {
            toSlider.style.zIndex = 2;
        } else {
            toSlider.style.zIndex = 0;
        }
    }

    const fromSlider = document.querySelector('#fromSlider');
    const toSlider = document.querySelector('#toSlider');
    const fromTooltip = document.querySelector('#fromTooltip');
    const toTooltip = document.querySelector('#toTooltip');

    if (fromSlider && toSlider) {
        fillSlider(
            fromSlider,
            toSlider,
            'rgba(0, 104, 180, 0.3)',
            'var(--color-primary-900)',
            toSlider,
            fromTooltip,
            toTooltip
        );
        setToggleAccessible(toSlider);

        fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromTooltip);
        toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toTooltip);
    }

    //fromTooltip.oninput = () => controlfromTooltip(fromSlider, fromTooltip, toTooltip, toSlider);
    //toTooltip.oninput = () => controltoTooltip(toSlider, fromTooltip, toTooltip, toSlider);
}